module.exports = __webpack_public_path__ + "static/tat6-32270ed1b01899aeb51cc2dc1d2ae914.jpg";